/**
 * Store de abertura do menu mobile (bottom sheet), Zustand, SEM persistência.
 * Consumido pelo botão "Mais" da barra inferior (BottomNavigation) e pela
 * folha (MobileMenuSheet), montada uma vez em AppShell.
 */

import { create } from 'zustand'

interface MobileMenuState {
  open: boolean
  setOpen: (value: boolean) => void
}

export const useMobileMenuStore = create<MobileMenuState>((set) => ({
  open: false,
  setOpen: (value) => set({ open: value }),
}))
